import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarPlus, Loader2, Trash2 } from "lucide-react";
import { addPlanItem, delPlanItem, errText, fetchLeadItems } from "@/lib/bf";

const today = () => new Date().toLocaleDateString("sv-SE", { timeZone: "Europe/Bucharest" });
const fmt = (d) => new Date(`${d}T12:00:00`).toLocaleDateString("ro-RO", { weekday: "long", day: "numeric", month: "long" });

export default function BFClientNext({ id }) {
  const [list, setList] = useState([]);
  const [f, setF] = useState({ date: "", time: "", note: "" });
  const [busy, setBusy] = useState(false);
  const load = useCallback(() => fetchLeadItems(id).then(setList).catch(() => toast.error("Nu am putut încărca programările")), [id]);
  useEffect(() => { load(); }, [load]);
  const save = () => {
    if (!f.date) return toast.error("Alege ziua vizitei");
    setBusy(true);
    addPlanItem({ lead: id, ...f }).then(() => { toast.success("Vizită programată. Apare în calendarul din Planificarea mea."); setF({ date: "", time: "", note: "" }); load(); window.dispatchEvent(new Event("bf-plan-changed")); })
      .catch((e) => toast.error(errText(e, "Nu am putut programa"))).finally(() => setBusy(false));
  };
  const del = (x) => delPlanItem(x.id).then(load).catch((e) => toast.error(errText(e, "Nu am putut șterge")));
  return (
    <div className="bfc-next" data-testid="bfc-next">
      <span className="st-label">Programează vizita următoare</span>
      <div className="bfc-visit-new">
        <input type="date" min={today()} value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} data-testid="bfc-next-date" />
        <input type="time" value={f.time} onChange={(e) => setF({ ...f, time: e.target.value })} data-testid="bfc-next-time" />
        <input value={f.note} maxLength={200} onChange={(e) => setF({ ...f, note: e.target.value })} placeholder="Ce vrei să discuți la vizită (opțional)" data-testid="bfc-next-note" />
        <button type="button" className="st-btn st-btn--silver" onClick={save} disabled={busy} data-testid="bfc-next-save">{busy ? <Loader2 size={14} className="animate-spin" /> : <CalendarPlus size={14} />} Programează</button>
      </div>
      {!!list.length && (
        <ul className="bfc-visits is-next" data-testid="bfc-next-list">
          {list.map((x) => (
            <li key={x.id} data-testid={`bfc-next-${x.id}`}>
              <b>{fmt(x.date)}{x.time ? ` · ${x.time}` : ""}</b><span>{x.note || "Vizită programată"}</span><small>{x.by || ""}</small>
              <button type="button" onClick={() => del(x)} aria-label="Șterge programarea" data-testid={`bfc-next-del-${x.id}`}><Trash2 size={14} /></button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
